export interface NameClaim {
  given_name?: string;
  additional_name?: string;
  family_name?: string;
}

export interface PreviousNameEntry {
  name?: NameClaim;
  [key: string]: unknown;
}

function normalize(value: string | undefined): string {
  return (value ?? "").trim().toLowerCase();
}

// Note: `NameClaim.additional_name` (middle name) is intentionally NOT used in
// the match logic. We only compare `given_name` and `family_name`, mirroring
// the original per-field comparison this util replaced. The full NameClaim is
// accepted as the input shape so callers can pass legal/document/previous-name
// records directly without restructuring them.
export function namesMatch(a: NameClaim, b: NameClaim): boolean {
  const aGiven = normalize(a.given_name);
  const aFamily = normalize(a.family_name);
  const bGiven = normalize(b.given_name);
  const bFamily = normalize(b.family_name);

  // A NameClaim with no given_name AND no family_name carries no identity
  // signal, so it must never match anything (otherwise an empty candidate
  // would silently match an empty previous_names entry and bypass the gate).
  if (aGiven === "" && aFamily === "") return false;
  if (bGiven === "" && bFamily === "") return false;

  return aGiven === bGiven && aFamily === bFamily;
}

export function nameMatchesApplicant(
  candidate: NameClaim,
  legalName: NameClaim,
  previousNames: PreviousNameEntry[]
): boolean {
  if (namesMatch(candidate, legalName)) {
    return true;
  }

  for (const entry of previousNames) {
    const prev = entry.name ?? {};
    if (namesMatch(candidate, prev)) {
      return true;
    }
  }

  return false;
}
